import { PhotoEventWithPricelistAndPhotos } from 'common-models';
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageIsLoading from "../../components/PageIsLoading";
import {
    useGetSingleEventWithPhotosQuery
} from "../../features/events/eventsApiSlice";

import "react-image-gallery/styles/css/image-gallery.css";

import EventPageContent from "src/components/events/EventPageContent";
import { useSiteTitle } from "src/context/SiteTitleContext";
import NotFound from "../NotFound";


const EventView: FC<any> = () => {
    const siteTitle = useSiteTitle();
    const params = useParams();

    const eventId = params.eventId as string;
    const imageId = params.imageId as string;

    console.info(`Image ID: ${imageId}`)
    // API CALLS
    const { data: photoEventFromApi = undefined, isLoading: photoEventFromApiIsLoading, isError: photoEventFromApiIsError } =
        useGetSingleEventWithPhotosQuery({ eventId: eventId });

    // STATE
    const [photoEventWithPricelistAndPhotos, setPhotoEventWithPricelistAndPhotos] = useState(
        undefined as unknown as PhotoEventWithPricelistAndPhotos
    );

    useEffect(() => {
        // console.info(`eventId was set to ${eventId}`);
        document.title = `${siteTitle.title}`;
        window.scrollTo(0, 0);
    }, [eventId, siteTitle.title]);

    useEffect(() => {
        document.title = photoEventFromApi?.event.title !== undefined ? `${siteTitle.title} - ${photoEventFromApi?.event.title}` : `${siteTitle.title}`;
        if (photoEventFromApi) {
            setPhotoEventWithPricelistAndPhotos(photoEventFromApi);
        }
    }, [photoEventFromApi, siteTitle.title]);

    if (photoEventFromApiIsError) {
        return <NotFound />
    }

    if (photoEventFromApiIsLoading || !photoEventWithPricelistAndPhotos) {
        return <PageIsLoading />
    }

    return <EventPageContent eventWithPricelistAndPhotos={photoEventWithPricelistAndPhotos} selectedImageId={imageId} />

};

export default EventView;
